import './footer.scss';

import React from 'react';

export default class extends React.PureComponent {


  render() {
    return (
      <footer className="footer">
        <p>
          Design and Build by <a href="https://nzdigital.co.nz">NZ Digital</a>
        </p>
      </footer>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/footer/index.js